import React, { useState, useEffect } from "react";
import {
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Button,
  Spinner,
} from "reactstrap";
import Select from "react-select";
import { useTranslation } from "context/TranslationProvider";
import helpers from "utils/helpers";

const RejectListingModal = ({ isOpen, toggle, onConfirm, isDeleted = false, isLoading = false }) => {
  const { t } = useTranslation();
  const [adminRemarks, setAdminRemarks] = useState([]);
  const rejectionOptions = helpers.getListingRejectionOptions(t);

  useEffect(() => {
    if (!isOpen) {
      setAdminRemarks([]);
    }
  }, [isOpen]);

  const handleConfirm = () => {
    if (adminRemarks.length === 0) return;
    onConfirm(adminRemarks);
  };

  return (
    <Modal 
      isOpen={isOpen} 
      toggle={isLoading ? undefined : toggle} 
      centered 
      backdrop={isLoading ? "static" : true}
      keyboard={!isLoading}
    >
      <ModalHeader toggle={isLoading ? undefined : toggle}>
        {t("page.userListings.rejectTitle", "Reject Listing")}
      </ModalHeader>
      <ModalBody>
        <Select
          isMulti={true}
          options={rejectionOptions}
          classNamePrefix="react-select"
          className="mb-2"
          placeholder={t("page.userListings.selectRejectReason", "Select rejection reason")}
          value={helpers.getSelectedOptions(adminRemarks, rejectionOptions)}
          onChange={(selected) => {
            setAdminRemarks(selected ? selected.map((opt) => opt.value) : []);
          }}
          isSearchable={true}
          closeMenuOnSelect={true}
          isDisabled={isLoading || isDeleted}
        />
        
        <textarea
          className="form-control heading-sm mt-3"
          rows="6"
          placeholder={t("page.users.details.remarksPlaceholder", "Select a reason for the rejection...")}
          value={helpers.getListingRemarksDisplay(adminRemarks, rejectionOptions)}
          disabled={isDeleted || isLoading}
          readOnly={true}
        />
      </ModalBody>
      <ModalFooter>
        <Button color="secondary" onClick={toggle} disabled={isLoading}>
          {t("create-listing.buttons.cancel", "Cancel")}
        </Button>
        <Button
          color="danger"
          onClick={handleConfirm}
          disabled={adminRemarks.length === 0 || isLoading || isDeleted}
          style={{ minWidth: "120px" }}
        >
          {isLoading ? (
            <>
              <Spinner size="sm" className="mr-2" />
              {t("page.userListings.rejectButton", "Reject")}
            </>
          ) : (
            t("page.userListings.rejectButton", "Reject")
          )}
        </Button>
      </ModalFooter>
    </Modal>
  );
};

export default RejectListingModal;
